// Order Status from metadata code 94
export var ORDER_STATUSES = {
  CANCELED: 3,
  COMPLETE: 2,
  OPEN: 1,
  PENDING: 0
};